import { defineComponent as _defineComponent } from 'vue'
import { Icons } from '@/icons/icons'

import { useI18n } from 'vue-i18n-composable'
import TextFieldComponent from '@/components/TextField/TextFieldComponent.vue'
import RememberCheckboxComponent from '@/components/forms/loginForm/RememberCheckboxComponent.vue'
import { ValidationObserver } from 'vee-validate'
import { computed, onUnmounted, reactive, ref } from 'vue'
import { Credentials } from '@/store/modules/auth/authTypes'
import { useAuthStore } from '@/stores/auth/useAuthStore'
import useAuthRedirect from '@/composables/useAuthRedirect'
import { AlertsData, AlertsTypes } from '@/store/modules/alerts/alertsTypes'
import StaticAlertComponent from '@/components/Alert/StaticAlertComponent.vue'
import useSpinner from '@/composables/useSpinner'


export default /*#__PURE__*/_defineComponent({
  __name: 'FormComponent',
  setup(__props) {

const icons = {
  mail: Icons.EMAIL,
  lock: Icons.LOCK,
  visible: Icons.VISIBLE
}

// TRANSLATIONS
const { t } = useI18n()
const { showSpinner, hideSpinner } = useSpinner()
const text = {
  password: t('views.login.password') as string,
  email: t('views.login.email') as string
}
const credentials = reactive<Credentials>({
  email: '',
  password: ''
})

const alert = computed<AlertsData>(() => {
  return {
    type: AlertsTypes.ERROR,
    message: t(authStore.error)
  }
})

const form = ref()

const authStore = useAuthStore()
const { redirectByUser } = useAuthRedirect()

const login = async () => {
  const formIsValid = await form.value.validate()
  if (!formIsValid) {
    return
  }
  showSpinner()

  await authStore.login(credentials)

  if (authStore.error) {
    console.error(authStore.error)
    hideSpinner()
  }
  redirectByUser()
}

onUnmounted(() => {
  hideSpinner()
})



return { __sfc: true,icons, t, showSpinner, hideSpinner, text, credentials, alert, form, authStore, redirectByUser, login, TextFieldComponent, RememberCheckboxComponent, ValidationObserver, StaticAlertComponent }
}

})